const { appendFilter } = require('../../../queries');
const addNotificationsQueries = require('../../../queries/configs/Notifications');

module.exports = addNotificationsQueries(function ({ payerId, baseUrl }) {
  return ({
    baseUrl: `${baseUrl}/${payerId}/notifications`,
    queriesFilter: appendFilter('payerId', payerId),
  })
});
